import { render, staticRenderFns } from "./AuthorLine.vue?vue&type=template&id=36c903fe&scoped=true"
import script from "./AuthorLine.vue?vue&type=script&lang=js"
export * from "./AuthorLine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c903fe",
  null
  
)

export default component.exports